import { Navigate, useLocation, useParams } from "react-router"
export default function ProtectedWrapper({children}) {
    const token = localStorage.getItem("access");
    const location = useLocation()
    const {event_slug} = useParams()
    if (!token) {

        return(
            <Navigate 
            to={`/events/${event_slug}/signin`}
            state={{ from: location.pathname}}
            replace
            />
        )
    }

    return children
}